import MATCHES from './matches.json';
import SIGN_PROFILES from './signs.json';
import { SIGNS, SIGN_BY_SLUG } from '../astro/signs';

export { MATCHES, SIGN_PROFILES };

export const SCORE_LABELS = [
  ['love', 'Love'],
  ['emotional', 'Emotional bond'],
  ['friendship', 'Friendship'],
  ['trust', 'Trust'],
  ['marriage', 'Marriage'],
  ['intimacy', 'Intimacy'],
];

const ORDER = SIGNS.map((sign) => sign.slug);

export function pairKey(a, b) {
  return [a, b].sort((x, y) => ORDER.indexOf(x) - ORDER.indexOf(y)).join('-');
}

export function matchFor(a, b) {
  return MATCHES[pairKey(a, b)];
}

export function pairSlug(man, woman) {
  return `${man}-man-${woman}-woman`;
}

export function pairPath(man, woman) {
  return `/zodiac-compatibility/${pairSlug(man, woman)}/`;
}

export function parsePairSlug(slug) {
  const found = /^([a-z]+)-man-([a-z]+)-woman$/.exec(slug || '');
  if (!found || !SIGN_BY_SLUG[found[1]] || !SIGN_BY_SLUG[found[2]]) return null;
  return { man: found[1], woman: found[2] };
}

export function loadPair(slug) {
  return import(`./pairs/${slug}.json`).then((module) => module.default || module);
}

export function scoreTone(score) {
  if (score >= 80) return 'high';
  if (score >= 65) return 'mid';
  return 'low';
}

export function rankedMatches(sign) {
  return ORDER
    .map((other) => ({ other, ...matchFor(sign, other) }))
    .sort((a, b) => b.overall - a.overall);
}
